import { ApiOperationItems } from "~enums/apiOperationItems.ts";
import { useApiOperations } from "~hooks/useApiOperations.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";
import { useGenerateReport } from "./useGenerateReport.ts";

export const useReportService = () => {
  const { mutateAsync: generateReportFn, isPending: isGeneratePending } = useGenerateReport();
  const { executeOrThrow } = useApiOperations(ApiOperationItems.REPORT);

  const generateReport = async (url: string, successMessageId: string): Promise<DefaultOperationSuccessResponse> =>
    executeOrThrow(() => generateReportFn(url), {
      successMessageId,
      isSucceeded: isDefaultOperationSucceeded,
    });

  return {
    generateReport,
    isGeneratePending,
  };
};
